import { useStore } from '@/legacy/store/zustand';

export const useNotifications = () => {
	const { notifications, addNotification, setNotifications, markAsRead, clearAllRead, clearOne } =
		useStore();

	return {
		notifications: Object.values(notifications).sort(
			(a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
		),
		addNotification,
		setNotifications,
		markAsRead,
		clearAllRead,
		clearOne,
	};
};
